import { useState } from 'react';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import { StartTrialModal } from '.'
const FitnessRewards = (props) => {
    return (
        <>
         <section className="bannerAreaN greyBackgroundN BannerDeatils position">
             <div className="detailsPageSection">
                <img src="https://res.cloudinary.com/vantagecircle/image/upload/w_1440,h_600/VantageFit/NewWebsite/pageBanner__compressed.png" alt="corporate wellness" className="img-responsive"/>
             </div>
             <div className="BannerContent">
                 <div className="headingBannerM container customCampaignContainer text-left ">
                    <div className="row">
                        <div className=" col-lg-8 col-xs-12 col-md-7 col-sm-12"> 
                        <h1>Fitness Rewards</h1>
                        <p className="colorwhite w7">
                        Compliment your employees' wellness journey with both non-monetary and monetary rewards.
                        </p>
                        <div className="mtb25">
                            <a href="/request-demo/" className="vfitwhitecta "> Schedule a Vantage Fit Demo</a>
                        </div>
                        </div>
                        <div className="col-lg-4  col-xs-12 col-md-5 col-sm-12 ">
                            <img alt="Step challenge" className ="mobileDisplay mobileimageW lozad" loading = "lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Banner_Images_fitnessrewards.png"/>
                        </div>
                    </div>
                </div>
             </div>

           
        </section>
        <section className="sectionSpacing greyBackgroundN pt-01 useCaseDesktop desktopView">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Feature Glance</div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <p className=" text-center title_spc secondarytext">Here’s a quick look at some of the key features of Vantage Fit.</p>
                    </div>
                    <div className="row_elementor features title_spc featuresN" id="featuresN">
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 left-activity rewardppints">
                            <div data-img="badges" className="box_item active-sec">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm badges"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm badges"></div>
                                </div>
                                <div className="featurestext">
                                    <div className="trackertext moodmeter">Badges</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Keep your employees motivated with unique badges that get unlocked every time they achieve a milestone.</div>
                            </div>
                           
                        </div>
                        <div className="col-lg-2 col-md-4 col-xs-12 col-sm-12 mid-activity hidden-xs hidden-sm">
                            <div id="badges">
                                <img width="300" height="600" className="mob_image Image-Overlay active-img lozad" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/FitnessRewards_Badges.png" alt="Step challenge" />
                            </div>
                            <div id="rewardPOints">
                                <img width="300" height="600" className="mob_image Image-Overlay" loading="lazy" src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/FitnessRewards_reward_points.png" alt="Walkathon" />
                            </div>
                            
                        </div>
                        <div className="col-lg-5 col-md-6 col-xs-12 col-sm-12 right-activity rewardppints">
                            
                            <div data-img="rewardPOints" className="box_item">
                                <div className="featuresimg">
                                    <div className="featuresSprite first-image activebox hidden-xs hidden-sm reawrdpoints"></div>
                                    <div className="featuresSprite second-image hidden-xs hidden-sm reawrdpoints"></div>
                                </div>
                                <div className="featurestext">
                                    <div className=" trackertext">Health<br/> Reward Points</div>
                                </div>
                                <div className="plusText featuresSprite activeBox"></div>
                                <div className="plusDisplayText onlineBox">Allocate redeemable reward points to your employees and instantly appreciate their efforts for taking up a lifestyle.</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 cta_center">
                    <a className = "starttrailCTa">
                        <div><StartTrialModal /></div>
                    </a></div>
                </div>
            </div>
        </section>
        <section className = "sectionSpacing position usecasemobile mobileview contestchallngM" id="useCasez">
          <div className = "container customCampaignContainer">
            <div className = "row">
              <div className = "col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className = "mainHeadingN ">
                  Features at a Glance
                </div>
                <div className = "subHeading">
                  Here’s a quick look at some of the key features of Vantage Fit.
                </div>
              </div>
            </div>
          </div>
           <div className="container customCampaignContainer " id = "useCasesz"> 
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter active">
                      <div className="useCasesBoxes  badges active featuresSpriteM"  attr = "Badges">Badges</div>
                    </div>
                  </div>
                <div className="col-lg-12 usecaseDesc active" id = "Badges">
                    <div className="onlineBox  row column-change  d-flex align_items_center  mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                           Keep your employees motivated with unique badges that get unlocked every time they achieve a milestone.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/FitnessRewards_Badges.png" alt = "Corporate wellness" className = "img-responsive lozad" loading = "lazy" />
                        </div>
                    </div>
                </div>
                <div className="row innerSpace">
                    <div className="col-lg-3 col-md-12 col-xs-12 col-sm-12 caseFilter">
                    <div className="useCasesBoxes reawrdpoints featuresSpriteM" attr = "rewardspoints">Reward Points</div>
                  </div>
                </div>
                <div className="col-lg-12 usecaseDesc" id = "rewardspoints">
                    <div className="onlineBox  row column-change  d-flex align_items_center mt_25">
                        <div className="col-lg-7 col-md-7 col-xs-12 col-sm-12 ">
                          Allocate redeemable reward points to your employees and instantly appreciate their efforts for taking up a lifestyle.
                        </div>
                        <div className="col-lg-5 col-md-5 col-xs-12 col-sm-12 ">
                            <img src = "https://res.cloudinary.com/vantagecircle/image/upload/v1607603447/VantageFit/NewWebsite/FitnessRewards_reward_points.png" alt = "corporate wellness program" className = "img-responsive lozad " loading = "lazy" />
                        </div>
                    </div>
                </div>\
            </div>
        </section>
        <section className="sectionSpacing ">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                        <div className="mainHeadingN text-center">Benefits</div>
                    </div>
                </div>
                <div className="row innerSpace  d-flex align-items-center column-change">
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6 featuresNbenefits">
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Inspire employees to keep up with their wellness journey.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Enhance participation rates with lucrative rewards on successful completion.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Increase the effectiveness of your wellness program with a transparent rewarding process.
                            </div>
                            <div className="onlineBox mt-3">
                                <span className="checkmark"></span>Redeem reward points as gift cards from within the app itself.
                            </div>
                        </div>
                        <div className = "col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <img src="https://res.cloudinary.com/vantagecircle/image/upload/VantageFit/NewWebsite/Fitness_rewards.png" alt="Step challenge" className="img-responsive lozad" loading = "lazy"/>
                        </div>
                </div>
            </div>
        </section>
         <section className="sectionSpacing featuresDetailsShape">
            <div className="container customCampaignContainer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">
                        <div className="colorwhite mainHeadingN">Schedule a Vantage Fit Demo</div>
                        <p className="colorwhite">How Corporate Wellness Program can Help Your Organisation</p>
                        <div className="mtb25 cta_center margb"><a href="https://www.vantagefit.io/request-demo/" className="vfitwhitecta ">Schedule a Demo</a></div>
                    </div>
                </div>
            </div>
        </section>
        
        </>
    );
}

export default FitnessRewards;



